import { Button, CircularProgress, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { useState } from "react";
import { useUpdateRecord } from "../../../api/useUpdateRecord";
import { useStore } from "../../../store/store";

type CancelResponseConfirmDialogProps = {
	responseId: string;
	onClose: () => void;
};

export const CancelResponseConfirmDialog = ({ responseId, onClose }: CancelResponseConfirmDialogProps) => {
	const { notifications } = useStore();
	const cancelResponse = useUpdateRecord();
	const [isCancelling, setIsCancelling] = useState(false);

	const handleConfirm = async () => {
		setIsCancelling(true);
		try {
			await cancelResponse.mutateAsync({
				entity: "instruments_responses",
				id: responseId,
				data: { status: "cancelled", password: null, password_expiration_date: null }
			});
			notifications.setNotification({
				isOpen: true,
				message: "Questionário cancelado com sucesso.",
				severity: "success"
			});
			onClose();
		} catch (error: any) {
			notifications.setNotification({
				isOpen: true,
				message: error?.response?.data?.errors?.[0]?.message || "Erro ao cancelar o questionário.",
				severity: "error"
			});
		} finally {
			setIsCancelling(false);
		}
	};

	return (
		<>
			<DialogContent>
				<DialogContentText>
					Esta ação irá cancelar o questionário e invalidar o link de acesso já enviado. Esta operação não
					pode ser revertida.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button color="secondary" onClick={onClose} disabled={isCancelling}>
					Voltar
				</Button>
				<Button onClick={handleConfirm} disabled={isCancelling}>
					{isCancelling ? <CircularProgress color="inherit" size={24} /> : "Cancelar questionário"}
				</Button>
			</DialogActions>
		</>
	);
};
